import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const instance = axios.create();

instance.interceptors.request.use((config) => {
  if (config?.headers) {
    config.headers['x-correlation-id'] = uuidv4();
    config.headers['x-api-key'] = import.meta.env.VITE_X_API_KEY ?? '';
  }
  return config;
});

export default instance;
